<template>
    <div>
    <div class="editor-menu" v-if="editor">
        <div @click="editor.chain().focus().toggleBold().run()" :class="{ 'is-active': editor.isActive('bold') }">Bold</div>
        <div @click="editor.chain().focus().toggleItalic().run()" :class="{ 'is-active': editor.isActive('italic') }">Italic</div>
        <div @click="setLink" :class="{ 'is-active': editor.isActive('link') }">Link</div>
        <div @click="editor.chain().focus().unsetLink().run()" v-if="editor.isActive('link')">Remove Link</div>
    </div>
    <editor-content :editor="editor" />
</div>
</template>

<script>
import { Editor, EditorContent } from '@tiptap/vue-2'
import StarterKit from '@tiptap/starter-kit'
import Link from '@tiptap/extension-link'
export default {
    components: {
        EditorContent
    },
    props: {
        modelValue: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            editor: null,
            localContent: this.modelValue,
        }
    },
    // watch: {
    //     localContent(value) {
    //         // HTML
    //         const isSame = this.editor.getHTML() === value
    //         // JSON
    //         // const isSame = this.editor.getJSON().toString() === value.toString()
    //         if (isSame) {
    //             return
    //         }
    //         this.editor.commands.setContent(value, false)
    //     }
    // },
    mounted() {
        this.editor = new Editor({
            extensions: [
                StarterKit,
                Link
            ],
            content: this.modelValue,
            onUpdate: () => {
                // HTML
                //this.$emit('update:modelValue', this.editor.getHTML())
                this.$emit('update', this.editor.getHTML())
                // JSON
                // this.$emit('update:modelValue', this.editor.getJSON())
            }
        })
    },
    methods: {
        setLink() {
            const url = window.prompt('Enter a complete URL for this link...')
            if (url) {
                this.editor.chain().focus().extendMarkRange('link').setLink({ href: url }).run()
            } else {
                this.editor.chain().focus().extendMarkRange('link').unsetLink().run()
            }
        }
    },
    beforeDestroy() {
        this.editor.destroy()
    }
}
</script>
<style lang="scss">
.editor-menu {
    div {
        font-size: 0.9em;
        display: inline-block;
        margin: 0 0 0 0;
        padding: 0.25em 0.5em;
        border: 1px solid #ccc;
        cursor: pointer;
        &.is-active {
            background-color: #ccc;
        }
    }
}
.ProseMirror {
    min-height: 9em;
    border: 1px solid #ccc;
    outline: 0 none;
    padding: 0.5em;
    a { font-weight: bold; font-family: Ariel, sans-serif; text-decoration: underline; }
}
</style>
